import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboardAt12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconClipboardAt12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.5 1h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M3.085 1H2.5A1.5 1.5 0 0 0 1 2.5v8A1.5 1.5 0 0 0 2.5 12h.55a3.5 3.5 0 0 1-.729-1.033A.5.5 0 0 1 2 10.5v-8a.5.5 0 0 1 .5-.5h.585A1.5 1.5 0 0 0 4.5 3h3a1.5 1.5 0 0 0 1.415-1H9.5a.5.5 0 0 1 .5.5v.837c.375.178.713.42 1 .714V2.5A1.5 1.5 0 0 0 9.5 1h-.585A1.5 1.5 0 0 0 7.5 0h-3a1.5 1.5 0 0 0-1.415 1M7 9.25c.445 0 1-.446 1-1.25s-.555-1.25-1-1.25S6 7.196 6 8s.555 1.25 1 1.25M8.2 6.2A1.85 1.85 0 0 0 7 5.75C5.895 5.75 5 6.757 5 8s.895 2.25 2 2.25a1.87 1.87 0 0 0 1.298-.538c.18.178.428.288.702.288h.5A1.5 1.5 0 0 0 11 8.5v-1A3.5 3.5 0 0 0 7.5 4h-1A3.5 3.5 0 0 0 3 7.5v1A3.5 3.5 0 0 0 6.5 12h3.944a.5.5 0 0 0 0-1H6.5A2.5 2.5 0 0 1 4 8.5v-1A2.5 2.5 0 0 1 6.5 5h1A2.5 2.5 0 0 1 10 7.5v1a.5.5 0 0 1-.5.5H9V6.6a.5.5 0 0 0-.8-.4"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboardAt12);
